export default __webpack_public_path__ + "static/media/rear.b6654df0.png";